// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Expln_React_Column = require("@expln/utils/src/main/Expln_React_Column.bs.js");
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var Paper = require("@mui/material/Paper").default;
var TextField = require("@mui/material/TextField").default;

function strOrNull(__x) {
  return Belt_Option.getWithDefault(__x, "");
}

var firstCharCode = "a".charCodeAt(0) | 0;

var lastCharCode = firstCharCode + 25 | 0;

var allChars = Belt_Array.concat(Belt_Array.map(Belt_Array.range(firstCharCode, lastCharCode), (function (prim) {
            return String.fromCharCode(prim);
          })), [
      "[",
      "]",
      "{",
      "}",
      ",",
      "<",
      ".",
      ">",
      "/",
      "?",
      ";",
      ":",
      "'",
      "\"",
      "\\",
      "|",
      "`",
      "~",
      "1",
      "!",
      "2",
      "@",
      "3",
      "#",
      "4",
      "$",
      "5",
      "%",
      "6",
      "^",
      "7",
      "&",
      "8",
      "*",
      "9",
      "(",
      "0",
      ")",
      "-",
      "_",
      "=",
      "+"
    ]);

function initRemainingKeys(param) {
  return Belt_Array.shuffle(allChars.slice(0));
}

function getFirstRemainingKey(keys) {
  return Belt_Option.getWithDefault(Belt_Array.get(keys, 0), "getFirstRemainingKey: ERROR");
}

function KeyTrainer(Props) {
  var match = React.useState(function () {
        return Belt_Array.shuffle(allChars.slice(0));
      });
  var setRemainingKeys = match[1];
  var remainingKeys = match[0];
  var match$1 = React.useState(function () {
        return getFirstRemainingKey(remainingKeys);
      });
  var setQuestion = match$1[1];
  var question = match$1[0];
  var match$2 = React.useState(function () {
        return false;
      });
  var setIsMistake = match$2[1];
  var acceptAnswer = function (str) {
    if (str === question) {
      Curry._1(setQuestion, (function (param) {
              var newRemainingKeys = remainingKeys.length <= 1 ? Belt_Array.shuffle(allChars.slice(0)) : Belt_Array.keepWithIndex(remainingKeys, (function (param, i) {
                        return i > 0;
                      }));
              Curry._1(setRemainingKeys, (function (param) {
                      return newRemainingKeys;
                    }));
              return getFirstRemainingKey(newRemainingKeys);
            }));
      return Curry._1(setIsMistake, (function (param) {
                    return false;
                  }));
    } else {
      return Curry._1(setIsMistake, (function (param) {
                    return true;
                  }));
    }
  };
  return React.createElement(Expln_React_Column.make, {
              justifyContent: "space-between",
              alignItems: "center",
              spacing: 2,
              style: {
                marginTop: "100px"
              },
              children: null
            }, React.createElement(Paper, {
                  style: {
                    color: match$2[0] ? "red" : "black",
                    fontFamily: "Courier New",
                    fontSize: "40px",
                    padding: "20px"
                  },
                  children: question
                }), React.createElement(TextField, {
                  value: "",
                  onChange: (function (param) {
                      return Expln_React_common.evt2str(acceptAnswer, param);
                    }),
                  autoFocus: true
                }));
}

var make = KeyTrainer;

exports.strOrNull = strOrNull;
exports.firstCharCode = firstCharCode;
exports.lastCharCode = lastCharCode;
exports.allChars = allChars;
exports.initRemainingKeys = initRemainingKeys;
exports.getFirstRemainingKey = getFirstRemainingKey;
exports.make = make;
/* firstCharCode Not a pure module */
